"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var radio_1 = __importDefault(require("relements/build/esm/input/radio"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var file_1 = __importDefault(require("relements/build/esm/input/file"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var info_svg_1 = __importDefault(require("@src/components/Icon/info.svg"));
var chat_icon_default_svg_1 = __importDefault(require("@src/components/Icon/chat-icon-default.svg"));
var chat_icon_smile_svg_1 = __importDefault(require("@src/components/Icon/chat-icon-smile.svg"));
var chat_icon_text_svg_1 = __importDefault(require("@src/components/Icon/chat-icon-text.svg"));
var chat_icon_placeholder_svg_1 = __importDefault(require("@src/components/Icon/chat-icon-placeholder.svg"));
var chat_icon_help_svg_1 = __importDefault(require("@src/components/Icon/chat-icon-help.svg"));
var chat_icon_outline_svg_1 = __importDefault(require("@src/components/Icon/chat-icon-outline.svg"));
var language_default_svg_1 = __importDefault(require("@src/components/Icon/language-default.svg"));
var devnagri_language_svg_1 = __importDefault(require("@src/components/Icon/devnagri-language.svg"));
var chatIcon_1 = __importDefault(require("../constants/chatIcon"));
require("./SDKChatIcon.scss");
var languageIcon_1 = __importDefault(require("../constants/languageIcon"));
var SDKChatIcon = function (_a) {
    var label = _a.label, options = _a.options, value = _a.value, primaryColor = _a.primaryColor, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.upload, upload = _c === void 0 ? true : _c, _d = _a.optionLabel, optionLabel = _d === void 0 ? true : _d;
    // This represents currenlty selected icon type.
    var _e = react_1["default"].useState(value), selectedIconType = _e[0], setSelectedIconType = _e[1];
    react_1["default"].useEffect(function () {
        setSelectedIconType(value);
    }, [value]);
    var containerRef = react_1["default"].useRef();
    react_1["default"].useEffect(function () {
        if (containerRef && containerRef.current && primaryColor) {
            containerRef.current.style.setProperty('--primary-color', primaryColor);
        }
    }, [primaryColor]);
    // Handle radio change.
    var onRadioChange = function (index) {
        var newType = {
            type: options[index].type,
            data: {
                imageURL: '',
            },
        };
        setSelectedIconType(newType);
        onChange(newType);
    };
    // Handle file uplaod event
    var onUrlChange = function (url) {
        var newType = __assign(__assign({}, selectedIconType), { data: {
                imageURL: url,
            } });
        setSelectedIconType(newType);
        onChange(newType);
    };
    /**
     * This method will return icon based on type
     * @param {type} type of chat icon
     */
    var getChatIcon = react_1["default"].useCallback(function (type) {
        switch (type) {
            case chatIcon_1["default"].IMAGE.type:
                return chat_icon_placeholder_svg_1["default"];
            case chatIcon_1["default"].TEXT.type:
                return chat_icon_text_svg_1["default"];
            case chatIcon_1["default"].SMILE.type:
                return chat_icon_smile_svg_1["default"];
            case chatIcon_1["default"].HELP.type:
                return chat_icon_help_svg_1["default"];
            case languageIcon_1["default"].DEFAULT.type:
                return language_default_svg_1["default"];
            case languageIcon_1["default"].DEVANAGARI.type:
                return devnagri_language_svg_1["default"];
            default:
                return chat_icon_default_svg_1["default"];
        }
    }, []);
    var chatIconClassName = optionLabel ? 'chat-icon' : 'chat-icon-optionLabel';
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { className: "chat-icon-label" }, label),
        react_1["default"].createElement("div", { className: "chat-icon-container " + (!optionLabel && 'center'), ref: containerRef }, options.map(function (item, index) {
            var IconComponent = getChatIcon(item.type);
            return (react_1["default"].createElement("div", { className: chatIconClassName },
                react_1["default"].createElement("div", { className: "chat-icon-radio" },
                    react_1["default"].createElement(radio_1["default"].Item, { label: optionLabel ? (item.label) : (react_1["default"].createElement(IconComponent, { className: "chat-icon-image-container-item" })), className: "chat-icon-radio-item", value: item.type === selectedIconType.type, onChange: function () { return onRadioChange(index); }, disabled: disabled }),
                    item.tooltip && (react_1["default"].createElement(icon_1["default"], { className: "chat-icon-radio-tooltip", src: info_svg_1["default"], tooltip: item.tooltip, tooltipPosition: "TOP" }))),
                optionLabel && (react_1["default"].createElement("div", { className: "chat-icon-image" },
                    react_1["default"].createElement("div", { className: "chat-icon-image-container" }, item.type === chatIcon_1["default"].IMAGE.type &&
                        selectedIconType.data.imageURL ? (react_1["default"].createElement("div", null,
                        react_1["default"].createElement("div", { className: "chat-icon-image-upload", style: {
                                backgroundImage: "url(" + selectedIconType.data.imageURL + ")",
                            } }),
                        react_1["default"].createElement(chat_icon_outline_svg_1["default"], null))) : (react_1["default"].createElement(IconComponent, { className: "chat-icon-image-container-item" }))))),
                upload && item.type === chatIcon_1["default"].IMAGE.type && (react_1["default"].createElement(file_1["default"], { onChange: onUrlChange, type: ".png, .jpeg, .gif", maxFileSize: 1 }, function (uploads, renderInput) {
                    var hide = selectedIconType.type !== chatIcon_1["default"].IMAGE.type;
                    return (react_1["default"].createElement("div", { className: "chat-icon-upload" },
                        react_1["default"].createElement(button_1["default"], { className: "chat-icon-upload-button", disabled: hide }, "Upload Here"),
                        !hide && renderInput()));
                }))));
        }))));
};
exports["default"] = SDKChatIcon;
